namespace advisorop.components.meetinghub {
    export class MeetingSchedulerController {
        public meetingHubMeetings: Array<domains.IMeeting>;
        public outlookEvents: Array<domains.IMeeting>;
        public calendars: Array<domains.IMeetingHubCalendar>;
        meetingDateRange: domains.IMeetingDateRange;
        user: domains.identity.IUser;
        onCreateMeeting: any;
        onEditMeeting: any;
        onDeleteMeeting: any;

        currentDate: Date = new Date();
        previousFromDate: Date = new Date();
        advisors: Array<domains.IAdvisor>;

        currentAdvisorId: number;
        households: Array<domains.IHousehold> = [];
        advisorHouseholds = new Map<number, Array<domains.IHousehold>>()

        investors: Array<domains.IInvestor> = [];
        advisorInvestors = new Map<number, Array<domains.IInvestor>>()

        schedulerOption: DevExpress.ui.dxSchedulerOptions;
        scheduler: DevExpress.ui.dxScheduler;

        calendarType = [{
            text: "Meeting Hub",
            id: -1,
            color: "#2a00ff"
        }, {
            text: "MS Graph",
            id: 1,
            color: "#2a9010"
        }, {
            text: "MS Graph2",
            id: 2,
            color: "#110010"
        }, {
            text: "MS Graph",
            id: 3,
            color: "#223344"
        }, {
            text: "MS Graph",
            id: 4,
            color: "#550099"
        }];

        constructor(private meetingHubService: services.MeetingHubService, private servicerService: services.ServicerService, private generalService: services.GeneralService) {
            var calendarResourceTypes = [{
                label: "Calendar",
                fieldExpr: "calendarId",
                dataSource: this.calendars,
            }];

            this.schedulerOption = {
                bindingOptions: {
                    dataSource: "vm.outlookEvents",
                    currentDate: "vm.currentDate",
                },
                views: ["day", "week", "month", "timelineDay"],
                currentView: "month",
                height: 600,
                //currentDate: new Date(),
                firstDayOfWeek: 0,
                startDayHour: 9,
                endDayHour: 23,
                showAllDayPanel: false,
                appointmentTemplate: "meeting-template",
                appointmentTooltipTemplate: "meeting-tooltip-template",
                resources: [
                    {
                        label: "Calendar",
                        fieldExpr: "calendarId",
                        dataSource: this.calendarType,
                    }
                ],
                appointmentDragging: {
                    onDragStart: e => {
                        // this will prevent a user from dragging appointments to a different date/time
                        // we may want to implement this in the future for a better user experience 
                        e.cancel = true;
                    }
                },
                onInitialized: e => {
                    this.scheduler = e.component;
                },
                onAppointmentFormOpening: data => {
                    data.cancel = true;
                    if (data.appointmentData.id == undefined) {
                        this.onCreateMeeting({ date: data.appointmentData.startDate });
                    } else {
                        // updating an existing meeting
                        var meeting = this.getMeetingByGuid(data.appointmentData.guid);
                        if (meeting == undefined) {
                            this.onCreateMeeting({ date: data.appointmentData.startDate });
                        }
                        else {
                            this.onEditMeeting({ meeting: meeting });
                        }
                    }
                    return;
                },
                onAppointmentDeleting: data => {
                    this.onAppointmentDeleting(data);
                },
                onOptionChanged: e => {
                    this.onOptionChanged(e);
                },
            };
        }

        onOptionChanged(e) {
            if (e.fullName.localeCompare("currentDate") == 0) {
                if (e.value < this.meetingDateRange.fromDate) {
                    this.meetingDateRange.fromDate = new Date(e.value.getFullYear(), e.value.getMonth(), 1);
                    return;
                }
                if (e.value >= this.meetingDateRange.toDate) {
                    this.meetingDateRange.toDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
                }
            }
            console.log(e);
        }

        onAdvisorChanged(e, form, meeting) {
            var advisorId = e.value;
            if (!Number.isFinite(advisorId)) {
                if (Number.isFinite(advisorId.id)) {
                    advisorId = advisorId.id
                }
                else {
                    advisorId = undefined;
                }
            }
            this.onAdvisorSelected(advisorId, form, meeting);
        }

        onAppointmentDeleting(data: any): void {
            var meeting = this.getMeetingByGuid(data.appointmentData.guid);
            if (meeting != undefined) {
                this.onDeleteMeeting({ meeting: meeting });
            }
        }

        getHouseholdSelectBoxOption(form: any, meeting?: domains.IMeeting, advisorId?: number): any {
            var reloadHouseholds = false;
            var householdId = (meeting != undefined ? (meeting.household != undefined ? meeting.household.id : undefined) : undefined);
            if (this.currentAdvisorId != undefined) {
                if (advisorId != undefined) {
                    if (this.currentAdvisorId != advisorId) {
                        // need to reload the households
                        this.currentAdvisorId = undefined;
                        this.households = [];
                        reloadHouseholds = true;
                    }
                } else {
                    this.currentAdvisorId = undefined;
                    this.households = [];
                }
            }
            var options = {
                items: this.households,
                displayExpr: item => {
                    if (item === undefined || item === null) {
                        return "";
                    }
                    return item.name;
                },
                value: householdId,
                valueExpr: "id",
                onValueChanged: e => {
                    var householdId = e.value;
                    this.onHouseholdSelected(householdId, form);
                },
                searchEnabled: true,
            };
            if (reloadHouseholds) {
                this.onAdvisorSelected(advisorId, form, meeting);
            }
            return options;
        };

        getInvestorTagBoxOption(investors: Array<domains.IInvestor>): any {
            var options = {
                items: investors,
                displayExpr: item => {
                    if (item === undefined || item === null) {
                        return "";
                    }
                    return item.fullName;
                },
                valueExpr: "id",
                showSelectionControls: true,
                applyValueMode: "useButtons",
            };
            return options;
        };

        refreshHouseholdSelectionBox(form, meeting, advisorId): void {
            form.itemOption("household", "editorOptions", this.getHouseholdSelectBoxOption(form, meeting, advisorId));
        }

        refreshInvestorsTagBox(form): void {
            form.itemOption("investors", "editorOptions", this.getInvestorTagBoxOption(this.investors))
        }

        onAdvisorSelected(advisorId, form, meeting): void {
            this.households = [];
            this.currentAdvisorId = undefined;
            if (this.advisorHouseholds.has(advisorId)) {
                this.households = this.advisorHouseholds.get(advisorId);
                this.currentAdvisorId = advisorId;
                this.refreshHouseholdSelectionBox(form, meeting, advisorId);
            } else {
                this.meetingHubService.getHouseholdsByAdvisor(advisorId).then(response => {
                    this.currentAdvisorId = advisorId;
                    this.households = response.data;
                    this.advisorHouseholds.set(advisorId, response.data);
                    this.refreshHouseholdSelectionBox(form, meeting, advisorId);
                }, err => this.generalService.showError(err));
            }

            this.investors = [];
            if (this.advisorInvestors.has(advisorId)) {
                this.investors = this.advisorInvestors.get(advisorId);
                this.refreshInvestorsTagBox(form);
            } else {
                this.meetingHubService.getInvestorsByAdvisor(advisorId).then(response => {
                    this.investors = response.data;
                    this.advisorInvestors.set(advisorId, response.data);
                    this.refreshInvestorsTagBox(form);
                }, err => this.generalService.showError(err));
            }
        };

        onHouseholdSelected(householdId, form): void {
            var householdInvestors = this.investors.filter(i => i.households.filter(h => h.id === householdId).length > 0);
            form.itemOption("investors", "editorOptions", this.getInvestorTagBoxOption(householdInvestors));
        };

        getMeetingByGuid(guid: string): domains.IMeeting {
            if (guid == undefined) {
                return {}
            }

            var meeting = this.meetingHubMeetings.find(m => {
                return m.guid === guid;
            });

            return meeting;
        }

        formatTimeAMPM(date: Date): string {
            var copyDate = new Date(date);
            var hours = copyDate.getHours();
            var minutes = copyDate.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            var txtMinutes = ('0' + minutes).slice(-2);
            var strTime = hours + ':' + txtMinutes + ' ' + ampm;
            return strTime;
        }

        getAppointmentTemplate(meeting: domains.IMeeting): string {
            var template = "<div>" + meeting.title + "</div>";
            if (meeting.guid != undefined) {
                var mhMeeting = this.getMeetingByGuid(meeting.guid);
                if (mhMeeting != undefined) {
                    // this is Meeting Hub event in Outlook
                    template += "<div><strong>Meeting Type: </strong>" + this.meetingType(mhMeeting) + "</div>"
                    if (mhMeeting.participants != undefined) {
                        template += "<div><strong>Participants</strong></div>";
                        mhMeeting.participants.forEach(p => {
                            if (p != null) {
                                template += "<div>" + p.name + "</div>";
                            }
                        })
                    }
                }
            }
            template += "<div>Start: " + this.formatTimeAMPM(meeting.startDate) + " - " + this.formatTimeAMPM(meeting.endDate) + "</div>"
            return template;
        }

        meetingType(meeting: domains.IMeeting): string {
            switch (meeting.type) {
                case domains.MeetingType.IN_PERSON: {
                    return "In Person";
                }
                case domains.MeetingType.PHONE: {
                    return "Phone call";
                }
                case domains.MeetingType.VIDEO: {
                    return "Video";
                }
                default: {
                    return "";
                }
            }
        }

        getAdvisor(): void {
            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                this.advisors = [];
                this.servicerService.getAdvisors(1).then(response => {
                    this.advisors = response.data;
                }, err => this.generalService.showError(err));
            }
        };

        $onInit(): void {
            this.getAdvisor();
        }

        $onChanges(evt): void {
            if (this.meetingDateRange != undefined) {
                if (this.previousFromDate.getTime() != this.meetingDateRange.fromDate.getTime()) {
                    if (this.currentDate == undefined || this.currentDate.getMonth() != this.meetingDateRange.fromDate.getMonth()) {
                        this.currentDate = this.meetingDateRange.fromDate;
                        this.previousFromDate = new Date(this.meetingDateRange.fromDate);
                    }
                } 
            }
            if (evt.calendars != undefined) {
                if (this.calendars.length > 0) {
                    if (this.scheduler != undefined) {
                        var resources = this.scheduler.option("resources");
                        console.log(resources);
                    }
                }
            }
            console.log(evt);
        }
    }

    class MeetingScheduler implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meetingHubMeetings: "<",
                outlookEvents: "<",
                meetingDateRange: "<",
                calendars: "<",
                user: "<",
                onCreateMeeting: "&",
                onEditMeeting: "&",
                onDeleteMeeting: "&"
            };
            this.controller = [`meetingHubService`, `servicerService`, `generalService`, MeetingSchedulerController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/views/meeting-scheduler.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingScheduler`, new MeetingScheduler());
}